import type { IconSvgObject } from './types';

const BitcoinMindIcon: IconSvgObject = [
  ["path", { d: "M15 22V18.5L17.876 18.8595C18.4728 18.9341 19 18.4687 19 17.8672V14.5L21 13L19 10C19 5.58172 15.4183 2 11 2C6.58172 2 3 5.58172 3 10C3 13.5452 5.30607 16.5518 8.5 17.6016M6 16.2454V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8.5 7H9.5M12 10H9.5M12 10C12.8284 10 13.5 9.32843 13.5 8.5C13.5 7.67157 12.8284 7 12 7H11M12 10C12.8284 10 13.5 10.6716 13.5 11.5C13.5 12.3284 12.8284 13 12 13H11M9.5 10V7M9.5 10V13M8.5 13H9.5M9.5 7H11M9.5 13H11M11 7V6M11 13V14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default BitcoinMindIcon;
